import { render } from "./EditableText.vue?vue&type=template&id=0ccfd0c4&scoped=true"
import script from "./EditableText.vue?vue&type=script&lang=js"
export * from "./EditableText.vue?vue&type=script&lang=js"

import "./EditableText.vue?vue&type=style&index=0&id=0ccfd0c4&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0ccfd0c4"]])

export default __exports__